import { call, select, all, take, put } from 'redux-saga/effects';
import {
  SET_PARAM_BRAND,
  SET_PARAM_LANGUAGE,
  SET_PARAM_PROXY_PREFIX,
} from '@corefront/redux-aba';
import { initLocalization } from '../../../services/localization';
import { setLocalizationInitialized } from '../../actions/app/initialization';
import {
  brandSelector,
  languageSelector,
  proxyPrefixSelector,
} from '../../reducers/app/params';
import { operatorIdSelector } from '../../reducers/app/configuration';
import { SET_IS_CONFIGURATION_LOADED } from '../../constants/initialization';

/**
 * Creates instance of locize and loads localization files
 */
export function* initializeLocalization() {
  // wait until required params would be set up
  yield all([
    take(SET_PARAM_LANGUAGE),
    take(SET_PARAM_BRAND),
    take(SET_PARAM_PROXY_PREFIX),
    take(SET_IS_CONFIGURATION_LOADED),
  ]);

  // get required params
  const language = yield select(languageSelector);
  const operatorId = yield select(operatorIdSelector);
  const brand = yield select(brandSelector);
  const proxyPrefix = yield select(proxyPrefixSelector);

  // init locize instance
  yield call(initLocalization, {
    lang: language,
    proxyPrefix,
    operatorId,
    brand,
  });
  yield put(setLocalizationInitialized(true));
}
